import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../app.auth.guard';
import { FinanzenComponent } from './finanzen.component';
import { GutschriftenComponent } from './gutschriften/gutschriften.component';
import { PrimanotaComponent } from './primanota/primanota.component';
import { KontenrahmenComponent } from './kontenrahmen/kontenrahmen.component';
import { KontenrahmenLayoutComponent } from './kontenrahmen/kontenrahmen-layout.component';
import { NebenkostenArtikelComponent } from './nebenkosten-artikel/nebenkosten-artikel.component';
import { FahrzeugeComponent } from './fahrzeuge/fahrzeuge.component';
import { HonorarTieraerzteComponent } from './honorar-tieraerzte/honorar-tieraerzte.component';
import { ErloesSuffixeComponent } from './erloes-suffixe/erloes-suffixe.component';
import { RechnungDetailsComponent } from './rechnungen/rechnung-details/rechnung-details.component';
import { RechnungenComponent } from './rechnungen/rechnungen.component';

const routes: Routes = [
    {
        path: '',
        component: FinanzenComponent,
        canActivate: [AuthGuard],
        children: [
            { path: 'rechnungen', component: RechnungenComponent, canActivate: [AuthGuard] },
            { path: 'rechnungen/:id', component: RechnungDetailsComponent, canActivate: [AuthGuard] },
            { path: 'gutschriften', component: GutschriftenComponent, canActivate: [AuthGuard] },
            { path: 'sonstige-erloese', redirectTo: '/wawi/bestellung-extern/sonstige-erloese', pathMatch: 'full' },
            { path: 'institutionen', redirectTo: '/lager/lieferanten/institutionen', pathMatch: 'full' },
            { path: 'sonstige-debitoren', redirectTo: '/lager/lieferanten/sonstige-kunden', pathMatch: 'full' },
            { path: 'buchen', redirectTo: '/lager/lieferanten/institutionen', pathMatch: 'full' },
            { path: 'primanota', component: PrimanotaComponent, canActivate: [AuthGuard] },
            {
                path: 'kontenrahmen',
                component: KontenrahmenLayoutComponent,
                canActivate: [AuthGuard],
                children: [
                    { path: '', component: KontenrahmenComponent, canActivate: [AuthGuard] },
                    { path: 'fahrzeuge', component: FahrzeugeComponent, canActivate: [AuthGuard] },
                    { path: 'honorar-tieraerzte', component: HonorarTieraerzteComponent, canActivate: [AuthGuard] },
                    { path: 'erloes-suffixe', component: ErloesSuffixeComponent, canActivate: [AuthGuard] },
                ],
            },
            { path: 'fahrzeuge', redirectTo: 'kontenrahmen/fahrzeuge', pathMatch: 'full' },
            { path: 'honorar-tieraerzte', redirectTo: 'kontenrahmen/honorar-tieraerzte', pathMatch: 'full' },
            { path: 'erloes-suffixe', redirectTo: 'kontenrahmen/erloes-suffixe', pathMatch: 'full' },
            { path: 'nebenkosten-artikel', component: NebenkostenArtikelComponent, canActivate: [AuthGuard] },
        ],
    },
];

@NgModule({ declarations: [], imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class FinanzenRoutingModule {}
